import React, { FunctionComponent } from 'react';

import { ErrorPage } from '../../../../../components/error-page';
import { ErrorPageType } from '../../../../../components/error-page/types';
import { Header } from '../../../../../components/header';
import { Notifications, Pages } from './components';

interface DefaultViewProps {
    hiddenHeader: boolean;
    withChat?: boolean;
    errorPageType: ErrorPageType | null;
    onCallOverlayHide?: () => void;
    isPlanningDisabled?: boolean;
}

export const DefaultView: FunctionComponent<DefaultViewProps> = ({
    hiddenHeader,
    withChat,
    errorPageType,
    onCallOverlayHide,
    isPlanningDisabled,
}) => {
    return (
        <>
            {errorPageType ? (
                <>
                    {errorPageType !== ErrorPageType.UNSUPPORTED_TOUCH && <Header hidden={hiddenHeader} />}
                    <ErrorPage />
                </>
            ) : (
                <>
                    <Header hidden={hiddenHeader} />
                    <Pages
                        isPlanningDisabled={isPlanningDisabled}
                        onCallOverlayHide={onCallOverlayHide}
                        withChat={withChat}
                    />
                </>
            )}
            <Notifications withChat={withChat} />
        </>
    );
};
